import React from 'react';
import classNames from 'classnames';

const toneClassNames = {
  brand: 'nima-loading-visual--brand',
  light: 'nima-loading-visual--light',
  teal: 'nima-loading-visual--teal'
};

/**
 * Visual decorativo compartilhado pelo indicador e pela surface.
 *
 * Porte de MVF/packages/ui/src/shared/loading/NimaLoadingIndicator.tsx:46-67.
 * O simbolo oficial da NIMA e a mascara: ele nunca recebe transform nem
 * animacao; so a faixa de luz do pseudo-elemento se move.
 */
const NimaLoadingVisual = ({ size = 'md', tone = 'brand', className, style }) => (
  <span
    aria-hidden="true"
    className={classNames(
      'nima-loading-visual',
      'nima-loading-visual--' + size,
      toneClassNames[tone],
      className
    )}
    style={style}
  >
    <span className="nima-loading-visual__dot-halo" />
    <span className="nima-loading-visual__mark" />
  </span>
);

export default NimaLoadingVisual;
